export enum EnumDeviceType {
    MERCADOPAGO = 0,
    MERCADOPAGO_DEV = 1,
    NAVIGATOR = 2,
    CORDOVA = 3
}